import { injectIntl } from 'react-intl';
import AddBookingForm from './AddBookingForm';

export default injectIntl(AddBookingForm);
